// extracted by mini-css-extract-plugin
export default {"container":"QD-z","dimension":"RD-z","dimensionLabels":"SD-z"};